import { useEffect } from 'react';
import { WizardStepBaseProps } from '../../../../wizard/interfaces/wizard-step-base-props';
import { PipelineReview } from '../../../PipelineReview/PipelineReview';
import { useEditPipelineContext } from '../../hooks/useEditPipelineContext';

export function EditPipelineReview({
  updateWizardStepFooterProps,
  controller
}: WizardStepBaseProps) {
  const { pipeline } = useEditPipelineContext();

  useEffect(() => {
    return () => {
      updateWizardStepFooterProps({});
    };
  }, []);

  return (
    <PipelineReview
      pipeline={pipeline!}
      controller={controller}
      title='Summary'
      onStateUpdate={props => {
        updateWizardStepFooterProps({
          ...props,
          children: 'Save & Exit'
        });
      }}
      subtitle='Review the configurations before saving the Pipeline. The edited configurations are highlighted in <span class="text-bold text-default">bold</span>'
      isEditing
    />
  );
}
